import { PictoPoids, PictoColis, PictoPalette, PictoTemperature } from "./LogisticsIcons";

// Bande logistique de la fiche produit, au format du catalogue Frites Dorées :
// 4 pictos officiels + valeur. Chaque case n'apparaît que si la donnée existe
// dans le JSON produit ; sans aucune donnée, la bande n'est pas rendue
// (les fiches non renseignées restent strictement inchangées).
const ITEMS = [
  { key: "poids_unite", label: "Poids", Icon: PictoPoids },
  { key: "conditionnement", label: "Colis", Icon: PictoColis },
  { key: "colis_par_palette", label: "Colis / palette", Icon: PictoPalette },
  { key: "temperature_conservation", label: "Conservation", Icon: PictoTemperature },
];

const clean = (v) => (typeof v === "string" ? v.trim() : v == null ? "" : String(v));

export function LogisticsBand({ product }) {
  const items = ITEMS.map((it) => ({ ...it, value: clean(product?.[it.key]) })).filter((it) => it.value);
  if (!items.length) return null;

  return (
    <div className="mt-10 border-t border-white/10 pt-8" data-testid="product-logistics">
      <p className="tag-label text-[#FFC300] mb-5">Logistique</p>
      <ul
        className="grid divide-x divide-white/15"
        style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
      >
        {items.map(({ key, label, value, Icon }) => (
          <li key={key} className="flex flex-col items-center text-center px-1.5 sm:px-3" data-testid={`logistics-${key}`}>
            <Icon className="h-9 sm:h-11 w-auto [&_.fd-ink]:fill-zinc-200 [&_.fd-accent]:fill-[#FFC300]" />
            <span className="mt-3 font-display text-base sm:text-lg font-semibold text-white leading-tight [overflow-wrap:anywhere]">
              {value}
            </span>
            <span className="mt-1 text-[9px] sm:text-[11px] uppercase tracking-[0.06em] sm:tracking-[0.12em] text-zinc-500 leading-snug">
              {label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
